import AccessibilityIcon from "components/Icons/AccessibilityIcon"
import CompaniesIcon from "components/Icons/CompaniesIcon"
import ContactUsIcon from "components/Icons/ContactUsIcon"
import FacebookIcon from "components/Icons/FacebookIcon"
import InstagramIcon from "components/Icons/InstagramIcon"
import MailIcon from "components/Icons/MailIcon"
import PhoneIcon from "components/Icons/PhoneIcon"
import TwitterIcon from "components/Icons/RedesignIcons/socialIcons/Twitter"
import WhatsAppIcon from "components/Icons/RedesignIcons/socialIcons/WhatsAppIcon"
import TikTokIcon from "components/Icons/TikTokIcon"
import WhatsappIcon from "components/Icons/WhatsappIcon"
import YoutubeIcon from "components/Icons/YoutubeIcon"

export type LinksType = {
  title: string
  link: string
  blank?: boolean
  iconName?: string
  iconComp?: JSX.Element
  onlyShowLogin?: boolean
  hebrewTitle?: string
}

export type NavigationLinksType = {
  [key: string]: LinksType
}

export type NestedNavigationLinksType = {
  title: string
  links: LinksType[]
}
const Links: NavigationLinksType = {
  "יצירת קשר בווטסאפ": {
    title: "יצירת קשר בווטסאפ",
    link: "https://api.whatsapp.com/send?phone=972545738031",
    blank: true,
  },
  "הזמנת כרטיסים לארגונים": {
    title: "הזמנת כרטיסים לארגונים",
    link: "https://api.whatsapp.com/send?phone=972545738031",
    blank: true,
  },
  "מקדונלד׳ס ישראל": {
    title: "מקדונלד'ס ישראל",
    link: "https://www.mcdonalds.co.il/",
    blank: true,
  },
  "בירור יתרה": {
    title: "בירור יתרה",
    link: "/balance",
    blank: false,
  },
  "שאלות תשובות": {
    title: "שאלות תשובות",
    link: "/faq",
    blank: false,
  },
  "הצהרת נגישות": {
    title: "הצהרת נגישות",
    link: "/accessibility",
    blank: false,
  },
  "מדיניות הפרטיות אונליין": {
    title: "מדיניות הפרטיות אונליין",
    link: "https://www.mcdonalds.co.il/שונות/מדיניות_פרטיות",
    blank: false,
  },
  "תנאי שימוש": {
    title: "תנאי שימוש",
    link: "/terms",
    blank: false,
  },
  "מפת אתר": {
    title: "מפת אתר",
    link: "/sitemap",
    blank: false,
  },
  "הנחיות לכתיבה נאותה": {
    title: "הנחיות לכתיבה נאותה",
    link: "/ethics",
    blank: false,
  },
  "הזמנת גיפטקארד חברה": {
    title: "הזמנת גיפטקארד חברה",
    link: "/companies",
    blank: false,
  },

  Facebook: {
    title: "Facebook",
    hebrewTitle: "פייסבוק",
    link: "https://www.facebook.com/mcdonaldsil",
    iconName: "facebook",
    iconComp: <FacebookIcon />,
    blank: true,
  },
  Instagram: {
    title: "Instagram",
    hebrewTitle: "אינסטגרם",
    link: "https://www.instagram.com/mcdonalds_israel/",
    iconName: "instagram",
    iconComp: <InstagramIcon />,
    blank: true,
  },
  Tiktok: {
    title: "Tiktok",
    hebrewTitle: "טיק טוק",
    link: "https://www.tiktok.com/@mcdonalds_il",
    iconName: "tiktok",
    iconComp: <TikTokIcon />,
    blank: true,
  },
  Youtube: {
    title: "Youtube",
    hebrewTitle: "יוטיוב",
    link: "https://www.youtube.com/c/McDonaldsIsrael",
    iconName: "youtube",
    iconComp: <YoutubeIcon />,
    blank: true,
  },
  WhatsappIcon: {
    title: "ווטסאפ",
    hebrewTitle: "ווטסאפ",
    link: "https://www.whatsapp.com/channel/0029VaG4JAu6RGJ9ptfG6c16",
    iconName: "whatsapp",
    iconComp: <WhatsAppIcon />,
    blank: true,
  },
  Twitter: {
    title: "X",
    hebrewTitle: "טוויטר",
    link: "https://twitter.com/McDonaldsIL",
    iconName: "X",
    iconComp: <TwitterIcon />,
    blank: true,
  },
  ContactUs: {
    title: "צרו קשר",
    link: "/",
    iconName: "ContactUsIcon",
    iconComp: <ContactUsIcon />,
  },
  Phone: {
    title: "03-7622035",
    link: "/tel:03-7622035",
    iconName: "phone",
    iconComp: <PhoneIcon />,
  },
  Mail: {
    title: "info@lehamim.co.il",
    link: "/",
    iconName: "mail",
    iconComp: <MailIcon />,
  },
  Whatsapp: {
    title: "ווטסאפ",
    link: "https://www.whatsapp.com/channel/0029VaG4JAu6RGJ9ptfG6c16",
    iconName: "whatsapp",
    iconComp: <WhatsappIcon />,
  },
  McOrder: {
    title: "mcdonald order",
    link: "https://order.mcdonalds.co.il/?sw=1&utm_source=gift_card&utm_medium=link&utm_campaign=gift_card&shortlink=unbnu6mo&c=Giftcard&pid=GiftCard_site",
    blank: true,
  },
  McOrderAndroid: {
    title: "mcdonald order android",
    link: "https://play.google.com/store/apps/details?id=il.co.inmanage.mcdonalds&hl=iw&gl=US",
    blank: true,
  },
  McOrderIphone: {
    title: "mcdonald order iphone",
    link: "https://apps.apple.com/il/app/%D7%9E%D7%A7%D7%93%D7%95%D7%A0%D7%9C%D7%93%D7%A1-mcdonalds-israel/id967762450",
    blank: true,
  },
  AccessibilityIcon: {
    title: "accessibility",
    link: "/accessibility",
    blank: false,
    iconName: "accessibility",
    iconComp: <AccessibilityIcon />,
  },
  CompaniesIcon: {
    title: "companies",
    link: "/companies",
    blank: false,
    iconName: "companies",
    iconComp: <CompaniesIcon />,
  },
}

const MenuLinksTop: LinksType[] = [
  Links["מגשי אירוח"],
  Links["חנויות המאפיה"],
  Links["מי אנחנו"],
  Links["צרו קשר"],
]

const MenuLinksBottom: LinksType[] = [Links["תעודת כשרות"], Links["תקנון"]]

// const obj = { hi:"1" };
// const objClone = { ...obj,showInLogIn:true; };

const FooterLinks: LinksType[] = [
  Links["יצירת קשר בווטסאפ"],
  Links["הזמנת גיפטקארד חברה"],
  Links["מקדונלד׳ס ישראל"],
  Links["בירור יתרה"],
  Links["שאלות תשובות"],
  Links["הצהרת נגישות"],
  Links["מדיניות הפרטיות אונליין"],
  Links["תנאי שימוש"],
  Links["מפת אתר"],
]

const GeneralLinks: LinksType[] = [
  Links["יצירת קשר בווטסאפ"],
  Links["הזמנת גיפטקארד חברה"],
  Links["מקדונלד׳ס ישראל"],
  Links["בירור יתרה"],
  Links["שאלות תשובות"],
  Links["הצהרת נגישות"],
  Links["תנאי שימוש"],
  Links["הנחיות לכתיבה נאותה"],
  Links["מפת אתר"],
]

const SocialLinks: NestedNavigationLinksType = {
  title: "עקבו אחרינו",
  links: [Links["FaceBook"], Links["Instagram"]],
}

const ContactUsLinks: NestedNavigationLinksType = {
  title: "דברו איתנו",
  links: [Links["Whatsapp"], Links["Phone"], Links["ContactUs"]],
}

const HeaderSocialLinks: NestedNavigationLinksType = {
  title: "עקבו אחרינו",
  links: [Links["CompaniesIcon"], Links["AccessibilityIcon"]],
}

const FooterSocialLinks: NestedNavigationLinksType = {
  title: "עקבו אחרינו",
  links: [
    Links["WhatsappIcon"],
    Links["Instagram"],
    Links["Tiktok"],
    Links["Facebook"],
    Links["Twitter"],
    Links["Youtube"],
  ],
}

const McOrderLinks: NestedNavigationLinksType = {
  title: "mcdonald order",
  links: [Links["McOrderAndroid"], Links["McOrderIphone"], Links["McOrder"]],
}

export {
  ContactUsLinks,
  FooterLinks,
  FooterSocialLinks,
  GeneralLinks,
  HeaderSocialLinks,
  McOrderLinks,
  MenuLinksBottom,
  MenuLinksTop,
  SocialLinks,
}
